import React from 'react'
import PropTypes from 'prop-types'
import { propType } from 'graphql-anywhere'
import ReactImgix from 'react-imgix'
import classnames from 'classnames'
import { Link } from 'react-router-dom'

import { getTileRecipe } from '../../imgix/recipes'
import { useScreenWidth } from '../../../hooks/use-screen-width'
import { getDetailsUrl } from '../../../lib/utils'

import rentalBadgeSmall from '../../../../images/neon/rental-badge-small.svg'
import TILE_FRAGMENT from '../../../../graphql/fragments/tile.gql'

import styles from './slide.css'

function TileSlide({ tile, className, hasBottomGradient }) {
  const { image, contentItem } = tile
  const screenWidth = useScreenWidth()
  const tileRecipe = getTileRecipe(screenWidth < 768 ? 'TILE_SLIDE_MOBILE' : 'TILE_SLIDE_DESKTOP')

  let width = 0
  let height = 0
  if (tileRecipe.width) {
    width = tileRecipe.width
    height = width * tileRecipe.ratio
  } else {
    height = tileRecipe.height
    width = height / tileRecipe.ratio
  }

  return (
    <Link
      to={getDetailsUrl(contentItem)}
      className={classnames(className, styles.slideWrapper)}
    >
      {contentItem.isRental && (
        <img
          className={styles.rentalBadge}
          src={rentalBadgeSmall}
          alt="Rental Content"
        />
      )}

      <div className={styles.imageWrapper}>
        <ReactImgix
          className={styles.image}
          src={image}
          width={width}
          height={height}
        />
      </div>
      <div
        className={classnames(styles.overlay, {
          [styles.isRental]: contentItem.isRental
        })}
      />
      {hasBottomGradient && (
        <div className={styles.bottomGradient} />
      )}
    </Link>
  )
}

TileSlide.propTypes = {
  tile: propType(TILE_FRAGMENT).isRequired,
  className: PropTypes.string,
  hasBottomGradient: PropTypes.bool
}

TileSlide.defaultProps = {
  className: '',
  hasBottomGradient: false
}

export default TileSlide
